import { FULL_HD, HD, RENDERING_CONTEXT, safetyMargins } from '@bedrock-rdk/constants';
import { HEIGHT as FACET_HEIGHT, BORDER_WIDTH as FACET_BORDER } from '../facet/facet.style';
import { makeDefaultStylingContext } from '../utils/style';

export const defaultContext = makeDefaultStylingContext();

export { FACET_BORDER, FACET_HEIGHT };

export const HEIGHT = {
  [HD]: FACET_HEIGHT[HD] + FACET_BORDER[HD] * 2,
  [FULL_HD]: FACET_HEIGHT[FULL_HD] + FACET_BORDER[FULL_HD] * 2,
};

export const TOP_OFFSET_BY_RENDERING_CONTEXT = {
  [RENDERING_CONTEXT.SEARCH]: {
    [FULL_HD]: 0,
    [HD]: 0,
  },
  [RENDERING_CONTEXT.GENERAL]: safetyMargins.vertical,
};

export const getInitialStyle = () => ({
  Row: {
    flex: {
      direction: 'row',
    },
  },
});
